<!-- src/views/HomePage.vue -->
<template>
    
    <div style="background: #1e2f36;color: #fff;width: 100%;    height: 100%;margin-top: -80px;padding-top: 100px;">
     <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;background: #1e2f36;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <span>应用领域 </span>
          <h1>与 Franka 共赴艺术之旅</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
            Franka 机器人已走进世界各地的音乐厅、博物馆、美术馆和舞台——它们并非作为机器，而是作为创意合作伙伴。以下是一系列不断扩充的艺术项目，展示了我们机器人的另一面。
          </span>
        </div> 
        <div class="display-width c-text-both">
          <img src="@/assets/images/applications/frida robot painting.jpg" alt=""
            style="height: auto; max-width: 100%;"> 
        </div>
      </div> 
      
     <div id="product-add-ons"></div>
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">展览与设计</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 40px;background: #1e2f36;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>文化机构中的机器人</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
           Franka：设计研究的主题与媒介——在顶尖文化机构中展出，探索 AI、机器人及人类创造力的交融
          </span>
        </div> 
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-column " v-for="item in frankaList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 450;">
            <img :src="item.url" alt=""  class="image-style" v-show="!item.iframeValue">
            <div class="playButton "    v-show="item.videoUrl" @click="item.iframeValue = true"> 
            </div>
            <iframe
                :src="item.videoUrl" v-if="item.iframeValue"
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                allowfullscreen="true"
                ></iframe> 
          </div>
          <div style="text-align: left;">   
            <span style="font-size: 14px;">{{item.title}}</span>
            <div class="c-text-align">
              <div style="font-size: 24px;margin: 10px 0;">{{item.name}}</div>
                <span  v-show="item.name=='Franka GELLO'" class="c-ml-5 bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
              原型</span>
            </div> 
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          <div style="text-align: left;margin-top: 10px;"> 
            <a  class="linkTag" :href="item.contentUrl" target="_blank">立即了解</a>
          </div>
        </div> 
      </div> 
      
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">绘画与素描</span>
        <hr class="divider">
      </div> 
      
      <div class="c-text-between px-container c-flex-wrap " style="background: #1e2f36;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>作为绘画工具的机器人手臂</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
            从自主的画笔描边到书法、涂鸦，这些项目将机器人手臂作为一种绘画工具进行探索——精准、不知疲倦，且富有惊人的表现力。
          </span>
        </div> 
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-column " v-for="item in accessoriesList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 450;">
            <img :src="item.url" alt=""  class="image-style" v-show="!item.iframeValue">
            <div class="playButton"    v-show="item.videoUrl" @click="item.iframeValue = true"> 
            </div>
            <iframe
                :src="item.videoUrl" v-if="item.iframeValue"
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                allowfullscreen="true"
                ></iframe> 
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <div style="font-size: 24px;margin: 10px 0;">{{item.name}}</div>
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          
          <div style="text-align: left;margin-top: 10px;"> 
            <a  class="linkTag" :href="item.contentUrl" target="_blank">立即了解</a>
          </div>
        </div> 
      </div> 
      
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">音乐与表演</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap " style="background: #1e2f36;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>Franka 登台演出</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
            这些项目将 Franka 带上舞台——作为管弦乐队乐手、大提琴手、吉他手以及舞伴。重新定义机器人表演的意义。
          </span>
        </div> 
      </div> 
      <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="module-width c-text-column " v-for="item in artList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 450;">
            <img :src="item.url" alt=""  class="image-style" v-show="!item.iframeValue">
            <div class="playButton"    v-show="item.videoUrl" @click="item.iframeValue = true"> 
            </div>
            <iframe
                :src="item.videoUrl" v-if="item.iframeValue"
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                allowfullscreen="true"
                ></iframe> 
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <div style="font-size: 24px;margin: 10px 0;">{{item.name}}</div>
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          
          <div style="text-align: left;margin-top: 10px;"> 
            <a  class="linkTag" :href="item.contentUrl" target="_blank">立即了解</a>
          </div>
        </div> 
      </div> 
       <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">其他</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap " style="background: #1e2f36;">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>你最想不到会出现机器人的地方</h1> 
          <span class="c-mt-5 c-mb-5" style="text-align: left;"> 
            从数字时装秀到电影片场，Franka 已经出现在一些出乎意料的场合。
          </span>
        </div> 
      </div> 
      <div class="other-list-layout px-container" style="margin-bottom: 120px;">
        <div class="module-width c-text-column " v-for="item in otherList" :key="item.name" style="margin-bottom: 60px;">  
          <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716 / 450;">
            <img :src="item.url" alt=""  class="image-style" v-show="!item.iframeValue">
            <div class="playButton"    v-show="item.videoUrl" @click="item.iframeValue = true"> 
            </div>
            <iframe
                :src="item.videoUrl" v-if="item.iframeValue"
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                allowfullscreen="true"
                ></iframe> 
          </div>
          <div style="text-align: left;">   
            <span>{{item.title}}</span>
            <div style="font-size: 24px;margin: 10px 0;">{{item.name}}</div>
            <span class="c-mt-5 c-mb-5" > 
            {{item.content}}
            </span>
          </div>
          
          <div style="text-align: left;margin-top: 10px;" v-if="item.contentUrl"> 
            <a  class="linkTag" :href="item.contentUrl" target="_blank">立即了解</a>
          </div>
        </div> 
      </div> 
    </div>
  </template>
  
  <script>
   
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'HomePage',
    data(){
      return{ 
        frankaList:[
          {
            title:'现代艺术陈列馆 / 慕尼黑工业大学机器人与机器智能研究所',
            name:'人工智能·机器人·设计',
            url:require('@/assets/images/applications/ki robotik design.jpg'),
            contentUrl:'https://www.pinakothek-der-moderne.de/en/exhibitions/ai-robotic-design/',
            videoUrl:'',
            iframeValue:false,
            content:'一场关于人工智能、机器人及设计领域的里程碑式展览，在慕尼黑的现代艺术陈列馆（Pinakothek der Moderne）举办，由慕尼黑工业大学（TUM）的慕尼黑机器人与机器智能研究所（MIRMI）合作策划。'
          },
          {
            title:'SOMABOTICS / LANCEL & MAAT',
            name:'拥抱天使',
            url:require('@/assets/images/applications/hqdefault (26).jpg'),
            contentUrl:'https://www.somabotics.ac.uk/project/embrace-angels/',
            videoUrl:'',
            iframeValue:false,
            content:'一个创意人工智能具身项目，于2025年10月在阿姆斯特丹Cinekid节上展出，由艺术家Lancel & Maat创作。'
          },
          {
            title:'上海纽约大学',
            name:'机械臂的艺术化探索',
            url:require('@/assets/images/applications/hqdefault (28).jpg'),
            contentUrl:'https://ima.shanghai.nyu.edu/projects/faculty-research/robotic-arms-art',
            videoUrl:'',    
            iframeValue:false,
            content:'来自上海纽约大学交互媒体艺术（IMA）项目的教师研究，探索机器人操控在表现力与艺术方面的潜力。'
          },
        ],
        
        accessoriesList:[
          {
            title:'卡内基梅隆大学',
            name:'FRIDA——艺术发展框架与机器人计划',
            url:require('@/assets/images/applications/frida robot painting-1.jpg'),
            content:'一款能够自主生成并执行笔触构图的机器人，将人工智能生成的概念转化为实体画作。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://arxiv.org/html/2302.04850v2'
          },
          {
            title:'LIRMM / 加内什·高里尚卡尔',
            name:'融合涂鸦机器人',
            url:require('@/assets/images/applications/hqdefault (29).jpg'),
            content:'一款将人类与机器手势融合的机器人，用于在公共空间创作大型涂鸦作品。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://www.lirmm.fr/ganesh-gowrishankar/a-touch-of-art/'
          },
          {
            title:'沃达丰',
            name:'GIGA 5G 人像',
            url:require('@/assets/images/applications/hqdefault (30).jpg'),
            content:'一款远程呈现绘图机器人，通过5G传输人类手势，在远端实时创作肖像。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://www.vodafone.de/featured/article/zukunftstechnologien-beim-axel-springer-award-vernetzte-kunst-mit-dem-vodafone-giga-5g-portrait-118258'
          },
          {
            title:'CLB 柏林 / 伦敦大学金史密斯学院 DeepMind',
            name:'LABOR — 机器人书法',
            url:require('@/assets/images/applications/hqdefault (31).jpg'),
            content:'一项探索手写与机器笔迹之间界限的机器人书法项目，在 CLB 柏林展出。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://clb-berlin.de/en/exhibitions/labor/'
          },
          {
            title:'洛桑大学 / 洛桑大学医院 / 西尔万·卡利农',
            name:'德罗兹机器人',
            url:require('@/assets/images/applications/DrozBot.png'),
            content:'一款受雅凯-德罗兹18世纪自动机启发的绘画机器人，在洛桑手部博物馆展出。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://calinon.ch/drozbot.htm'
          },
          {
            title:'朗根基金会 / 朱利安·沙里埃',
            name:'可控燃烧',
            url:require('@/assets/images/applications/Controlled Burn.png'),
            content:'一台烟火绘画机器，通过在有机物上烧灼留下痕迹，在诺伊斯的朗根基金会展出。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://langenfoundation.de/en/exhibitions/julian-charriere-controlled-burn'
          },
           
        ],
        
        artList:[
          {
            title:'海勒劳节日剧院 / 德累斯顿工业大学',
            name:'机器人交响曲',
            url:require('@/assets/images/applications/hqdefault (32).jpg'),
            content:'一台多臂机器人在德国顶尖当代艺术场馆之一与现场管弦乐团同台演奏。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://techxplore.com/news/2024-10-armed-robot-german-orchestra.html'
          },
          {
            title:'苏黎世美术馆 / 奥拉维尔·埃利亚松',
            name:'大提琴演奏机器人',
            url:require('@/assets/images/applications/cello.jpg'),
            content:'一位机器人大提琴手，作为奥拉维尔·埃利亚松在苏黎世美术馆展览的一部分，探索非人类的音乐表现力。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://www.thestrad.com/news/cello-playing-robot-forms-part-of-exhibition-at-the-kunsthaus-zurich/10405.article'
          },
          {
            title:'佐治亚理工学院 — 音乐技术中心',
            name:'吉他机器人',
            url:require('@/assets/images/applications/hqdefault (33).jpg'),
            content:'一个兼具吉他手与舞者身份的机器人，探索信任、即兴创作以及人机表演之间的关系。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://www.gilweinberg.com/guitarbot'
          },
        ],
        otherList:[
          {
            title:'菲利普·普莱因',
            name:'时尚已亡',
            url:require('@/assets/images/applications/hqdefault (34).jpg'),
            content:'一场由菲利普·普莱因呈现的全机器人数字时装秀——没有模特、没有观众、没有规则。Franka 登上T台。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:''
          },
          {
            title:'Netflix',
            name:'《生化黑客》—— 剧集出镜',
            url:require('@/assets/images/applications/jasper-mia-lorenz-secret-lab.jpg'),
            content:'一台 Franka 机器人在 Netflix 科幻剧集《生化黑客》中亮相，出现在一个未来感十足的研究实验室场景中。',
            videoUrl:'',
            iframeValue:false,
            contentUrl:'https://www.netflix.com/hk-en/title/81011660'
          },
        ]
      }
    }
  };
  </script>
<style scoped> 
h1{
  color: #fff;
}
.divider{
    border-top: 1px solid #ffffff !important;
}
.action-height{
  height: 400px;
  background-color: #d5dbdc; 
  position: relative;
}
.module-width{
  width: calc(33% - 40px);
}
.other-list-layout{
  display: grid;
  grid-template-columns: repeat(3, calc(33% - 40px));
  justify-content: space-between;
}
.other-list-layout .module-width{
  width: 100%;
}
/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .module-width{
    width: calc(50% - 40px);
  }
  .other-list-layout{
    grid-template-columns: repeat(2, calc(50% - 40px));
  }
  .action-height{
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .module-width{
    width: calc(100% - 40px);
  }
  .other-list-layout{
    grid-template-columns: calc(100% - 40px);
  }
} 

</style>
  
